import React, { useState } from 'react';
import { Check, ShoppingBag } from 'lucide-react';

interface ProductCardProps {
  product: {
    id: number;
    name: string;
    description: string;
    price: number;
    image: string;
  };
  index?: number;
}

const ProductCard: React.FC<ProductCardProps> = ({ product, index = 0 }) => {
  const [added, setAdded] = useState(false);

  const handleAddToCart = () => {
    setAdded(true);
    setTimeout(() => setAdded(false), 2000);
  };

  return (
    <div
      className="card-base overflow-hidden group animate-on-scroll"
      style={{ transitionDelay: `${(index % 3) * 0.1}s` }}
    >
      <div className="relative overflow-hidden h-64 bg-secondary p-4">
        <img
          src={product.image}
          alt={product.name}
          className="w-full h-full object-contain transition-transform duration-700 group-hover:scale-110"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
      </div>

      <div className="p-6">
        <h3 className="text-xl font-heading font-bold mb-2 text-primary group-hover:text-accent transition-colors">
          {product.name}
        </h3>
        <p className="text-gray-500 mb-4 text-sm leading-relaxed">{product.description}</p>
        <div className="flex justify-between items-center">
          <span className="text-2xl font-heading font-bold text-primary">
            {product.price} <span className="text-sm font-normal text-gray-400">MDL</span>
          </span>
          <button
            onClick={handleAddToCart}
            className={`flex items-center gap-2 px-5 py-2.5 rounded-lg font-semibold text-sm transition-all duration-300 transform hover:scale-105 active:scale-95 ${
              added
                ? 'bg-green-600 text-white'
                : 'bg-accent hover:bg-accent-dark text-white'
            }`}
          >
            {added ? (
              <>
                <Check className="h-4 w-4" />
                Adăugat
              </>
            ) : (
              <>
                <ShoppingBag className="h-4 w-4" />
                Adaugă în Coș
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProductCard;
